import qs from 'qs';
import event from '../../event';
import Logging from './logging';

const Auth = {
    namespaced: true,

    state: {
        token: localStorage.apiToken ? localStorage.apiToken : '',
        authToken: localStorage.authToken ? localStorage.authToken : '',
        adminFullname: localStorage.fullName ? localStorage.fullName : '',
    },

    getters: {

        /**
         * Отдает токен
         * @param state
         * @returns {*}
         */
        getToken(state) {
            return state.token;
        },

        /**
         * Флаг, авторизован ли пользователь
         * @param state
         * @returns {boolean}
         */
        isAuth(state) {
            if (typeof localStorage.apiToken != 'undefined') {
                return !!localStorage.apiToken;
            } else {
                return !!state.token;
            }
        },

        /**
         * Полное имя авторизованного пользователя
         * @param state
         * @returns {string|*}
         */
        adminFullname(state) {
            return state.adminFullname;
        },
    },

    mutations: {

        /**
         * Установка авторизационных данных
         * @param state
         * @param token
         * @param fullname
         */
        setAuth(state, { token, fullname }) {
            state['token'] = token;
            state['adminFullname'] = fullname;
        },

        eraseLocalStorageItems() {
            try {
                localStorage.removeItem('fullName');
                localStorage.removeItem('authToken');
                localStorage.removeItem('apiToken');
                localStorage.removeItem('lastVisitedPage');
            } catch (e) {
                console.debug(e);
            }
        },
    },


    actions: {
        /**
         * Авторизация в приложении
         * @param commit
         * @param dispatch
         * @param rootGetters
         * @param data
         * @returns {Promise<any>}
         */
        auth({ commit, dispatch, rootState, rootGetters }, data) {
            event.supressionFlag = false;
            return new Promise((resolve, reject) => {
                const str = JSON.stringify(data);
                axios({
                    url: rootGetters.rootUrl + 'poh/login',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'type': 'auth',
                        'data': str
                    }),
                }).then(response => {
                    if (response.data.length !== 0) {
                        commit('setAuth', {
                            token: response.data[0].apiKey,
                            fullname: response.data[0].fullname
                        });
                        //        dispatch('getAllData');
                        resolve(true);
                    } else {
                        resolve(false);
                    }
                }).catch(err => {
                    console.log('ERROR IN auth.js | auth : ' + err);
                    reject(false);
                });
            });
        },

        /**
        * @param commit
        * @param dispatch
        * @param rootGetters
        * @param data
        * @returns {Promise<any>}
        */
        async isValidApiKey({ commit, dispatch, rootState, rootGetters }) {
            let testApiKey,
                storedApiKey = this.getters['auth/getToken'];

            if (localStorage.getItem('authToken') != null) {

                let username = 'admin',
                    password = 'admin';

                let token = localStorage.getItem('authToken');

                if (typeof token == 'undefined') {
                    return false;
                }

                let otpServiceBasePath = rootGetters.mfaUrl,
                    otpAssertTokenPath = 'auth/check';

                const credentials = btoa(`${username}:${password}`)
                const auth = {
                    "Authorization": `Basic ${credentials}`,
                    "jwt": token,
                    "Accept": "application/json, text/plain, */*",
                    "Content-Type": "application/json;charset=utf-8"
                }

                let url = encodeURI(`${otpServiceBasePath}${otpAssertTokenPath}`);

                let response;
                let result;

                try {

                    const requestOptions = {
                        method: "POST",
                        headers: auth,
                        redirect: "follow"
                    };

                    response = await fetch(url, requestOptions)
                        .then((response) => {
                            if (typeof response == 'undefined') {
                                result = false;
                            }
                            if (response.status != 200) {
                                result = false;
                            }
                            response.text().then((status) => {
                                result = status;
                                console.warn(status)
                            });
                        })
                        .catch((error) => console.error(error));

                    result = true;
                } catch (e) {
                    result = false;
                }

                console.log(result)

                if (!result) {
                    commit('eraseLocalStorageItems');
                    event.supressionFlag = true;
                    return false;
                } else {
                    console.warn('authToken ok')
                }

                await axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                    data: qs.stringify({
                        'token': storedApiKey,
                        'service': rootGetters.service.checkApiKey,
                    }),
                }).then(response => (
                    testApiKey = response,
                    dispatch('loading/isLoading', false, { root: true }),
                    !testApiKey.data[0].status ? window.getApp.$emit(`APP_DATA_RECIEVE_ERROR`, `Ключ API недействителен`) : ''
                    //window.getApp.$emit(`APP_DATA_RECIEVE_${testApiKey.data[0].status ? 'SUCCESS' : 'ERROR'}`, `Ключ API ${testApiKey.data[0].status ? 'действителен' : 'недействителен'}`)
                )).catch(err => {
                    dispatch('loading/isLoading', false, { root: true }),
                        window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при проверке API ключа: ' + err);
                        event.supressionFlag = true;
                        return false;
                });

                if (!testApiKey.data[0].status) {
                    commit('eraseLocalStorageItems');
                    event.supressionFlag = true;
                    return false;
                }

                console.log('isValidApiKey:', testApiKey.data[0].status);
                return testApiKey.data[0].status;

            } else {
                commit('eraseLocalStorageItems');
                event.supressionFlag = true;
                return false;
            }
        },

        eraseLocalStorageItems(keepPage = true) {
            try {
                localStorage.removeItem('fullName');
                if (!keepPage) {
                    localStorage.removeItem('lastVisitedPage');
                }
                localStorage.removeItem('apiToken');
                localStorage.removeItem('authToken');
            } catch (e) {
                console.debug(e);
            }
        },

        setLocalStorageItems(apiToken, fullname) {
            let lastVisitedPage = 'staffs/accounts';

            if (typeof apiToken != 'undefined') {
                if (localStorage.lastVisitedPage != 'undefined' && localStorage.lastVisitedPage != null) {
                    lastVisitedPage = localStorage.lastVisitedPage;
                } else {
                    localStorage.lastVisitedPage = lastVisitedPage;
                }

                localStorage.fullName = fullname;
                localStorage.apiToken = apiToken;

                console.debug(localStorage.fullName, localStorage.lastVisitedPage, localStorage.apiToken);
            } else {
                return false;
            }

            return true;
        },

        /**
         * Выход из приложения
         * @param commit
         * @returns {Promise<any>}
         */
        logout({ commit }) {
            return new Promise((resolve, reject) => {
                commit('eraseLocalStorageItems');
                commit('setAuth', {
                    token: '',
                    fullname: ''
                });
                resolve(true);
            })
        },
    },
};

export default Auth;


// WEBPACK FOOTER //
// ./src/store/modules/auth.js